// src/components/HomePage.js
import React, { useEffect, useState } from 'react';
import './HomePage.css';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'

// Import Font Awesome components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Import additional Font Awesome icons
import { faPills, faDatabase, faLock, faCode, faMobileAlt, faBarChart } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import screenshot1 from '../assets/images/screenshot1.png'; // Replace with your actual image paths
import screenshot2 from '../assets/images/screenshot2.png';
import sagarhomeo from '../assets/images/sagarhomeo.png';


// Add icons to the library
library.add(fab, faPills, faDatabase, faLock, faBarChart, faMobileAlt);

const HomePage = () => {
  // State for carousel
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeNav, setActiveNav] = useState('home');
  const betatestingversion = "v2.45 Beta";

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const gclid = params.get('gclid') || '';
    console.log('GCLID:', gclid); // Log the GCLID value
    localStorage.setItem('gclid', gclid);
  }, []);



  const slides = [
    {
      icon: ['fab', 'react'],
      title: 'React',
      description: 'Build interactive UIs with ease using React’s component-based architecture.',
    },
    {
      icon: ['fab', 'google'],
      title: 'Google Cloud',
      description: 'Leverage scalable cloud infrastructure and services to deploy your applications.',
    },
    {
      icon: 'database', // Placeholder for Firebase
      title: 'Firebase',
      description: 'Utilize real-time databases and authentication services to manage your backend effortlessly.',
    },
    {
      icon: ['fab', 'github'],
      title: 'GitHub',
      description: 'Collaborate and manage your codebase efficiently with GitHub’s version control system.',
    },
    {
      icon: ['fab', 'python'],
      title: 'Python',
      description: 'Implement robust backend logic and data processing with Python’s versatile capabilities.',
    },
  ];

  const messages = [
    "Collect Customer Data and make Data Driven Decisions.",
    'Streamline your Clinic Operations with AI.',
    'Make your Clinic more efficient and profitable.',
  ];

  const episodes = [
    {
      title: 'Introduction to Collecting Customer Data',
      description: 'Accelerate your business by understanding Customer demands and preferences.',
      videoId: '8HslUzw35mc?si=k8Cv9HNmZFeUJnUj', // Replace with actual YouTube video ID
    },
  ];

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => {
      clearInterval(slideInterval);
    };
  }, [slides.length]);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setActiveNav(id);
    }
  };

  const handleNavClick = (id) => {
    scrollToSection(id);
  };

  const goToLogin = () => {
    navigate('/login');
  };

  const goToPricing = () => {
    navigate('/pricingpage');
  };

  const goToSignUp = () => {
    navigate('/signup');
  };

  return (
    <div className="unauth-homepage">
      {/* Navigation Bar */}
      <nav className="unauth-navbar">
        <div className="unauth-logo" onClick={() => handleNavClick('home')}>
          <FontAwesomeIcon icon="pills" className="unauth-header-icon" /> ClinicSync
        </div>
        <ul className="unauth-nav-links">
          <li>
            {betatestingversion}
          </li>
          <li
            className={activeNav === 'about' ? 'active' : ''}
            onClick={() => handleNavClick('about')}
          >
            About
          </li>
          <li
            className={activeNav === 'features' ? 'active' : ''}
            onClick={() => handleNavClick('features')}
          >
            Features
          </li>
          <li
            className={activeNav === 'pricing' ? 'active' : ''}
            onClick={() => goToPricing('pricing')}
          >
            Pricing
          </li>
          <li
            className={activeNav === 'testimonials' ? 'active' : ''}
            onClick={() => handleNavClick('testimonials')}
          >
            Testimonials
          </li>
          <li
            className={activeNav === 'cta' ? 'active' : ''}
            onClick={() => goToPricing('logins')}
          >
            Get Started
          </li>
          <li
            className={activeNav === 'logins' ? 'active' : ''}
            onClick={() => goToLogin('logins')}
          >
            Login
          </li>
        </ul>
      </nav>

      {/* Hero Section */}
      <header className="unauth-hero-section" id="home">
        <div className="unauth-hero-content">
          <h1>
            <FontAwesomeIcon icon="pills" className="unauth-header-icon" /> Most Simple software to manage your Clinic
          </h1>
          <p>Easily maintain customer data and make intelligent decisions. ClinicSync can be adopted in any type of clinic.</p>
          <Link to="/signup" className="unauth-cta-button">
            Get started
          </Link>
        </div>
      </header>
      {/* Scrolling Text Banner */}
      <section className="unauth-scrolling-banner">
        <div className="scrolling-text" id="about">
          {messages.map((message, index) => (
            <span key={index}>{message}</span>
          ))}
        </div>
      </section>

      <div className="homepage-sections">
        <h2 className='about-h2'>What is ClinicSync ?</h2>
        <p className='about-text'>ClinicSync is a simple yet powerful clinic management software designed for homeopathic, general, specialized, denatal and all types of clinics.
          With ClinicSync, you can easily manage patient records, schedule appointments, generate prescriptions, and track clinic activity — all in one secure place. Whether you run a single clinic or multiple branches, ClinicSync helps you save time, reduce paperwork, and streamline your day-to-day operations with zero technical hassle.</p>
        {/* Section 1 */}
        <div className="section section-left">
          <img src={screenshot1} alt="Dashboard Screenshot" className="section-image" />
          <div className="section-text">
            <h2>Manage Your Clinic Efficiently</h2>
            <p>
              Our intuitive dashboard allows you to easily manage appointments, patients, and prescriptions.
              Designed for speed and simplicity, so you can focus on what matters most — your patients.
            </p>
          </div>
        </div>

        {/* Section 2 */}
        <div className="section section-right">
          <div className="section-text">
            <h2>Secure, Multi-Tenant Architecture</h2>
            <p>
              Each clinic gets its own secure space. Your data is isolated and protected with a scalable Firestore backend.
              Set roles, assign access, and work with peace of mind.
            </p>
          </div>
          <img src={screenshot2} alt="Security Screenshot" className="section-image" />
        </div>
      </div>

      <section className="unauth-scrolling-banner"></section>

      {/* Features Section */}
      <section className="unauth-features" id="features">
        <h2>Features</h2>
        <div className="unauth-features-grid">
          <div className="unauth-feature-item">
            <FontAwesomeIcon icon="lock" size="3x" className="unauth-feature-icon" />
            <h3>Data Security</h3>
            <p>ClinicSync's data is stored in Google Firestore which ensures highest level of Data security.</p>
          </div>
          <div className="unauth-feature-item">
            <FontAwesomeIcon icon="bar-chart" size="3x" className="unauth-feature-icon" />
            <h3>Data Analytics</h3>
            <p>Analyze your customer/patients data to make informed decisions.</p>
          </div>
          <div className="unauth-feature-item">
            <FontAwesomeIcon icon="mobile-alt" size="3x" className="unauth-feature-icon" />
            <h3>Simple UI</h3>
            <p>Easy to use thanks to simple UI design so you can immediately adapt and focus on what matters most</p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="unauth-testimonials" id="testimonials">
        <h2>Clinics that have already started using</h2>
        <div className="unauth-testimonials-grid">
          <div className="unauth-testimonial-item">
            <p>"ClinicSync has transformed the way we manage our clinic. The intuitive interface and features have made our operations seamless."</p>
            <h4>- Dr. Anjali Mehta</h4>
          </div>
          <div className="unauth-testimonial-item">
            <img src={sagarhomeo} alt="Sagar Homeo Clinic" className="testimonial-image" />
            <h4>- Sagar Homeo</h4>
          </div>
          <div className="unauth-testimonial-item">
            <p>"Simple software, easy to use. Helpful to maintain customer info and manage appointments"</p>
            <h4>- Anonymous</h4>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="unauth-cta" id="cta">
        <h2>Ready to Transform Your Clinic?</h2>
        <Link to="/signup" className="unauth-cta-button">
          Sign Up Now
        </Link>
      </section>

      {/* Footer */}
      <footer className="unauth-footer">
        <div className="unauth-footer-content">
          <p>&copy; {new Date().getFullYear()} ClinicSync. All rights reserved.</p>
          <ul className="unauth-footer-links">
            <li onClick={() => navigate('/privacy')}>Privacy Policy</li>
            <li onClick={() => navigate('/terms')}>Terms of Service</li>
            <li onClick={() => navigate('/contact')}>Contact Us</li>
            <li onClick={() => navigate('/refunds')}>Refunds</li>
          </ul>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;